module.exports = __webpack_public_path__ + "img/half-circle-2.65b59610.svg";